import type { ApiResponse, components } from '@alqove/types';
import type { AlqoveClient } from '../client';

export type CategoryTree = components['schemas']['CategoryTree'];

export function createCategoryEndpoints(client: AlqoveClient) {
  return {
    list() {
      return client.get<ApiResponse<CategoryTree[]>>('/v1/categories');
    },
  };
}
